import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { TranslateModule } from '@ngx-translate/core';
import { InputEntryConfig } from '../../tp-integrations.interface';
import { AbstractCallComponent } from '../abstract-call/abstract-call.component';

@Component({
    selector: 'se-form-call',
    templateUrl: './form-call.component.html',
    styleUrls: ['../call-style/call.scss'],
    imports: [
        ReactiveFormsModule,
        MatFormFieldModule,
        MatSelectModule,
        MatInputModule,
        MatSlideToggleModule,
        MatButtonModule,
        TranslateModule,
    ],
    standalone: true,
})
export class FormCallComponent extends AbstractCallComponent implements OnInit, AfterViewInit {
    @ViewChild('formElement') formElement!: ElementRef;

    form = new FormGroup({});
    inputListConfig: InputEntryConfig[] = [];
    formSubmitted = false;

    ngAfterViewInit(): void {
        /*verificare se si puo saltare lo step perche abbiamo gia tutti i dati*/
        if (this.call.formConfig?.skipOnPreFill && this.areAllInputsPreFilled()) {
            return this.done();
        }
    }

    ngOnInit() {
        super.ngOnInit();
        this.prepareInputListConfig();
        this.createForm();
        this.formSubmitted = false;
    }

    areAllInputsPreFilled = (): boolean => {
        return this.inputListConfig.every((input) => {
            return input.initialValue !== null && input.initialValue !== undefined;
        });
    };

    prepareInputListConfig = () => {
        this.inputListConfig =
            this.call.formConfig?.inputList.map((inputConfig) => {
                /* se non e` specificato un path per i dati potrebbe non essere una select oppure
                 * i dati sono specificati in inputConfig.sourceData direttamente nel json*/
                if (!inputConfig.sourceDataPath) return inputConfig;

                const sourceData = Array.isArray(this.dataStore[inputConfig.sourceDataPath])
                    ? [...(this.dataStore[inputConfig.sourceDataPath] as any[])]
                    : [];

                let initialValue = inputConfig.initialValue ?? '';
                if (['select', 'multi-select'].includes(inputConfig.inputType)) {
                    initialValue = sourceData.length ? sourceData[0] : null;
                }

                return { ...inputConfig, initialValue, sourceData };
            }) || [];
    };

    createForm = () => {
        this.call.formConfig?.inputList.forEach((input, idx) => {
            let initialValue = input.initialValue ?? '';
            if (['select', 'multi-select'].includes(input.inputType)) {
                initialValue = this.inputListConfig[idx].sourceData[0];
            }

            this.form.addControl(
                input.name,
                new FormControl(initialValue, {
                    nonNullable: Boolean(input.nonNullable),
                    validators: input.required ? [Validators.required] : [],
                }),
            );
        });
    };

    handleSubmit = () => {};

    end = () => {
        if (this.call.formConfig?.isSubmitForm && !this.formSubmitted) {
            /* in questo caso viene fatta una post su url esterna*/
            this.formElement.nativeElement.submit();
            this.formSubmitted = true;
            return;
        }
        super.end();
    };

    done = () => {
        this.result = this.form.getRawValue();
        this.end();
    };

    close = () => {
        this.callThrowError.emit('FORCE_CLOSE');
    };
}
